<template>
  <div>
    <b-form>
      <input-text
        ref="nome"
        v-model="form.nome"
        :label="$t(`PESSOAS.NOME`)"
        placeholder="Digite um nome"
      />

      <input-select-search
        ref="tipoContatoId"
        :options="tiposContato"
        v-model="form.tipoContato"
        :label="$t('PESSOAS.TIPO_CONTATO')"
        placeholder="Selecione ou digite"
        required
      />

      <input-text
        ref="descricao"
        v-model="form.descricao"
        :label="$t('PESSOAS.DESCRICAO')"
        :contactType="contactType"
        required
      />

      <b-form-checkbox
        v-model="form.principal"
        :value="true"
        :unchecked-value="false"
      >
        <label>{{ $t('PESSOAS.CONTATO_PRINCIPAL') }}</label>
      </b-form-checkbox>
    </b-form>
    <div class="d-flex space-between w-100 mt-4">
      <b-button variant="secondary" @click="fecharForm">{{
        $t('GERAL.FECHAR')
      }}</b-button>
      <b-button variant="primary" @click="salvar">{{
        $t('GERAL.SALVAR')
      }}</b-button>
    </div>
  </div>
</template>

<script>
//aux & helpers
import { InputText, InputSelectSearch } from '@/components/inputs';

import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

//Services
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service';
import PessoaService from '@/common/services/pessoa/pessoa.service';

// TipoContatoEnum.Email no back
const TIPO_CONTATO_EMAIL = 249;

export default {
  components: {
    InputText,
    InputSelectSearch,
  },
  props: {
    pessoaId: { type: String, default: null },
    contato: { type: Object, default: null },
  },
  data() {
    return {
      tiposContato: [],
      form: {
        tipoContato: null,
        principal: false,
      },
    };
  },

  computed: {
    // Telefones ficam como texto livre (sem máscara); só o e-mail é validado
    contactType() {
      return this.form.tipoContato === TIPO_CONTATO_EMAIL ? 'E-mail' : '';
    },
  },
  mounted() {
    if (this.contato) {
      // cópia: sem salvar, a lista do modal não deve mostrar a alteração
      this.form = { ...this.contato, pessoaId: this.pessoaId };
    }
    this.form.entidadeId = this.pessoaId;
    this.listarTiposContatos();
  },
  methods: {
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
    salvar() {
      if (!this.validarFormulario()) return;
      this.$store.dispatch(START_LOADING);
      PessoaService.criarContato(this.form)
        .then(() => {
          this.$emit('atualizar');
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('PESSOAS.CONTATO_SALVO')
          );
          this.fecharForm();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    listarTiposContatos() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('tipo-contatos')
        .then(({ data }) => {
          this.tiposContato = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    fecharForm() {
      this.$emit('fechar');
    },
  },
  watch: {
    exibir(valor) {
      if (valor) {
        this.listarTiposContatos();
      }
    },
  },
};
</script>
